import React from 'react';
import { HashRouter as Router, Routes, Route, Link } from 'react-router-dom';

// --- 1. FULL INVENTORY (21 SPECIES) ---
const INVENTORY = [
  { id: 1, genus: "Pheidole", species: "dentata", qty: "1q 20-50w", price: 15, url: "https://square.link/u/HDt19sJR", outOfStock: false },
  { id: 2, genus: "Pheidole", species: "dentata", qty: "3q 20-50w", price: 25, url: "", outOfStock: true },
  { id: 3, genus: "Pheidole", species: "hyatti", qty: "1q 20-50w", price: 15, url: "https://square.link/u/D31QidRk", outOfStock: false },
  { id: 4, genus: "Pheidole", species: "hyatti", qty: "3q 20-50w", price: 25, url: "", outOfStock: true },
  { id: 5, genus: "Leptogenys", species: "elongata", qty: "1q 10-15w", price: 45, url: "", outOfStock: true },
  { id: 6, genus: "Pheidole", species: "lamia", qty: "1q", price: 12.5, url: "", outOfStock: true },
  { id: 7, genus: "Pheidole", species: "tysoni", qty: "1q", price: 12.5, url: "", outOfStock: true },
  { id: 8, genus: "Pheidole", species: "navigans", qty: "1q", price: 7, url: "", outOfStock: true },
  { id: 9, genus: "Pheidole", species: "bicarinata", qty: "1q", price: 12.5, url: "", outOfStock: true },
  { id: 10, genus: "Myrmecocystus", species: "semirufus", qty: "1q", price: 30, url: "", outOfStock: true },
  { id: 11, genus: "Myrmecocystus", species: "placodops 01", qty: "1q", price: 45, url: "https://square.link/u/BZmmpbLJ", outOfStock: false, featured: true },
  { id: 12, genus: "Myrmecocystus", species: "placodops 01", qty: "1q 1-5w", price: 70, url: "", outOfStock: true },
  { id: 13, genus: "Camponotus", species: "festinatus", qty: "1q 2-5w", price: 25, url: "", outOfStock: true },
  { id: 14, genus: "Camponotus", species: "festinatus", qty: "1q", price: 15, url: "https://square.link/u/TvJAQ4R1", outOfStock: false },
  { id: 15, genus: "Camponotus", species: "texanus", qty: "1q", price: 15, url: "https://square.link/u/0wUDV5zZ", outOfStock: false },
  { id: 16, genus: "Camponotus", species: "decipiens", qty: "1q", price: 15, url: "https://square.link/u/wclDUFJ1", outOfStock: false },
  { id: 17, genus: "Solenopsis", species: "geminata", qty: "Colony", price: 40, url: "", outOfStock: true },
  { id: 18, genus: "Solenopsis", species: "geminata x xyloni", qty: "Colony", price: 40, url: "", outOfStock: true },
  { id: 19, genus: "Camponotus", species: "sansabeanus", qty: "1q", price: 20, url: "", outOfStock: true },
  { id: 20, genus: "Myrmecocystus", species: "wheeleri", qty: "1q", price: 30, url: "", outOfStock: true },
  { id: 21, genus: "Atta", species: "texana", qty: "1q", price: 10, url: "", outOfStock: true }
];

// --- 2. STYLES ---
const bodyStyle = { fontFamily: '-apple-system, sans-serif', backgroundColor: '#f9f9f9', minHeight: '100vh', paddingBottom: '60px' };
const container = { maxWidth: '650px', margin: '0 auto', padding: '0 20px' };
const card = { background: 'white', padding: '25px', borderRadius: '20px', marginBottom: '25px', boxShadow: '0 4px 12px rgba(0,0,0,0.05)', color: '#333', lineHeight: '1.6' };
const setupStyle = { background: '#f0f4f2', padding: '15px', borderRadius: '12px', marginTop: '15px', fontSize: '0.9rem', borderLeft: '4px solid #1b4332' };

// --- 3. COMPONENTS ---

const Shop = () => {
  const grouped = INVENTORY.reduce((acc, ant) => {
    (acc[ant.genus] = acc[ant.genus] || []).push(ant);
    return acc;
  }, {});

  return (
    <div style={container}>
      {Object.keys(grouped).map(genus => (
        <section key={genus} style={{ marginBottom: '40px' }}>
          <h2 style={{ color: '#1b4332', borderBottom: '3px solid #1b4332', display: 'inline-block', marginBottom: '15px' }}>{genus}</h2>
          {grouped[genus].map(ant => (
            <div key={ant.id} style={{ background: 'white', padding: '20px', borderRadius: '16px', marginBottom: '12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', border: ant.featured ? '3px solid #ffca3a' : '1px solid #eee', opacity: ant.outOfStock ? 0.6 : 1 }}>
              <div>
                <h3 style={{ margin: 0, fontStyle: 'italic', fontSize: '1.1rem' }}>{ant.genus} {ant.species}</h3>
                <p style={{ margin: '5px 0 0 0', color: '#666', fontSize: '0.9rem' }}>{ant.qty}</p>
              </div>
              <button disabled={ant.outOfStock} onClick={() => !ant.outOfStock && window.open(ant.url, '_blank')} style={{ background: ant.outOfStock ? '#ccc' : '#1b4332', color: 'white', border: 'none', padding: '10px 18px', borderRadius: '10px', fontWeight: 'bold', cursor: 'pointer' }}>
                {ant.outOfStock ? 'OUT' : `$${ant.price}`}
              </button>
            </div>
          ))}
        </section>
      ))}
    </div>
  );
};

const CareGuide = () => (
  <div style={container}>
    <h1 style={{ textAlign: 'center', color: '#1b4332', marginBottom: '30px' }}>Species Database</h1>
    <section style={card}>
      <h2>Leptogenys elongata</h2>
      <p>Leptogenys elongata is a specialized ponerine ant that feeds almost exclusively on isopods (woodlice). They are slender, fast, and hunt in coordinated groups. Their environment must be kept very humid (80%+) and is best suited for a semi-naturalistic or bioactive setup with a soil substrate. They prefer stable temperatures between 24°C and 27°C.</p>
      <div style={setupStyle}><b>Recommended Setup:</b> Bioactive terrarium with leaf litter and constant isopod supply.</div>
    </section>
    <section style={card}>
      <h2>Camponotus sp. (Carpenter Ants)</h2>
      <p>Known as "Carpenter Ants," they are among the largest and hardiest ants in the hobby. They have a slow growth rate in the first year. Their diet should consist of liquid sugars and insects. Humidity: 30–50% with constant water access. Room temperature (72°F to 79°F) is ideal.</p>
      <div style={setupStyle}><b>Recommended Setup:</b> Acrylic or wood-based formicarium. Heat mat on one side only.</div>
    </section>
    <section style={card}>
      <h2>Pheidole (Big-Headed Ants)</h2>
      <p>Favorite for their major and minor castes. High protein (insects) and small seeds are required. Moderate to high humidity (60–70%). They are prolific escape artists; a high-quality fluon barrier is essential.</p>
      <div style={setupStyle}><b>Recommended Setup:</b> Gypsum or grout nest. Fine-mesh lids and double barriers.</div>
    </section>
    <section style={card}>
      <h2>Atta texana (Leafcutters)</h2>
      <p>Fungus farmers. They do not eat leaves, but use them to grow fungus. Expert-level species. Requires 80–90% humidity and stable temps (75°F to 79°F). Needs a huge variety of fresh, pesticide-free vegetation.</p>
      <div style={setupStyle}><b>Recommended Setup:</b> Modular multi-chambered acrylic setup.</div>
    </section>
    <section style={card}>
      <h2>Myrmecocystus (Honeypots)</h2>
      <p>Arid species with "repletes" that act as storage. Requires high heat (80°F to 90°F). Must provide vertical height for repletes to hang securely without touching the floor.</p>
      <div style={setupStyle}><b>Recommended Setup:</b> Replete-friendly nest with textured ceilings and 1-inch clearance.</div>
    </section>
  </div>
);

const ShippingPolicy = () => (
  <div style={container}>
    <h1 style={{ textAlign: 'center', color: '#1b4332', marginBottom: '30px' }}>Shipping & Guarantee</h1>
    <section style={card}>
      <h2 style={{ color: '#1b4332', marginTop: 0 }}>Live Arrival Guarantee (LAG)</h2>
      <p>I take pride in the health of every colony shipped. To qualify for LAG:</p>
      <ul>
        <li>Provide a continuous 1-minute unboxing video showing the condition of the ants.</li>
        <li>Contact <b>Sales@antsupplyguy.com</b> within 2 hours of delivery.</li>
        <li><b>Temperature Warning:</b> LAG is void if local highs are above 100°F or below 40°F unless "Hold for Pickup" is selected.</li>
      </ul>
    </section>
    <section style={card}>
      <h2>Shipping Schedule</h2>
      <p>To ensure the health of the colonies, orders are shipped <b>Monday, Tuesday, and Wednesday</b> via UPS 2-Day or Overnight. This prevents ants from being stuck in a warehouse over the weekend.</p>
    </section>
  </div>
);

const About = () => (
  <div style={container}>
    <h1 style={{ textAlign: 'center', color: '#1b4332', marginBottom: '30px' }}>About AntSupplyGuy</h1>
    <section style={card}>
      <p>Based in the beautiful Hill Country of <b>Lago Vista, Texas</b>, AntSupplyGuy is dedicated to the study and distribution of high-quality native ant species.</p>
      <p>What started as a fascination with the complex social structures of <i>Atta texana</i> and <i>Myrmecocystus</i> has grown into a specialized operation. Every queen and colony is gathered with precision and cared for using the exact methods outlined in our database.</p>
      <p>I believe that successful ant keeping starts with two things: high-quality specimens and the right knowledge. My goal is to provide both to the community, ensuring that every keeper—from beginner to expert—has the best chance of growing a thriving colony.</p>
    </section>
  </div>
);

// --- 4. MAIN EXPORT ---

export default function App() {
  return (
    <Router>
      <div style={bodyStyle}>
        <header style={{ padding: '40px 20px', textAlign: 'center' }}>
          <Link to="/"><img src="/logo.png.JPG" alt="Logo" style={{ width: '110px', height: '110px', borderRadius: '50%', border: '4px solid #1b4332', boxShadow: '0 4px 15px rgba(0,0,0,0.1)' }} /></Link>
          <h1 style={{ margin: '15px 0 5px', fontSize: '2.5rem' }}>
            <Link to="/" style={{ color: '#1b4332', textDecoration: 'none', fontWeight: '900' }}>AntSupplyGuy</Link>
          </h1>
          <nav style={{ marginTop: '20px' }}>
            <Link to="/" style={{ margin: '0 12px', color: '#1b4332', fontWeight: 'bold', textDecoration: 'none' }}>SHOP</Link>
            <Link to="/care" style={{ margin: '0 12px', color: '#1b4332', fontWeight: 'bold', textDecoration: 'none' }}>CARE</Link>
            <Link to="/shipping" style={{ margin: '0 12px', color: '#1b4332', fontWeight: 'bold', textDecoration: 'none' }}>SHIPPING</Link>
            <Link to="/about" style={{ margin: '0 12px', color: '#1b4332', fontWeight: 'bold', textDecoration: 'none' }}>ABOUT</Link>
          </nav>
        </header>

        <Routes>
          <Route path="/" element={<Shop />} />
          <Route path="/care" element={<CareGuide />} />
          <Route path="/shipping" element={<ShippingPolicy />} />
          <Route path="/about" element={<About />} />
        </Routes>

        <footer style={{ textAlign: 'center', marginTop: '60px', color: '#bbb', fontSize: '0.85rem' }}>
          <p>© 2026 AntSupplyGuy | Lago Vista, Texas</p>
          <a href="mailto:Sales@antsupplyguy.com" style={{ color: '#1b4332', textDecoration: 'none', fontWeight: 'bold' }}>Sales@antsupplyguy.com</a>
        </footer>
      </div>
    </Router>
  );
}
